import styled from 'styled-components';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import { deviceSizes } from '../../../../config/devices';
export var StyledDrawer = styled(Drawer).withConfig({
  displayName: "style__StyledDrawer",
  componentId: "sc-14qzc5e-0"
})([".MuiPaper-root{margin-top:64px;width:", ";display:flex;overflow-x:hidden;transition:width 225ms cubic-bezier(0.4,0,0.6,1) 0ms;}@media (max-width:", "){.MuiPaper-root{width:", ";}}"], function (_ref) {
  var open = _ref.open;
  return open ? '240px' : '60px';
}, deviceSizes.sm, function (_ref2) {
  var open = _ref2.open;
  return open ? '100%' : '0';
});
export var MenuButton = styled(IconButton).withConfig({
  displayName: "style__MenuButton",
  componentId: "sc-14qzc5e-1"
})(["width:60px;"]);